import axiosInstance from "../../axios/axiosInstance";
import { CREATE_SUB_CATEGORY, DELETE_SUB_CATEGORY, EDIT_SUB_CATEGORY, STATUS_UPDATE_SUB_CATEGORY, SUB_CATEGORY_LISTING, SUB_CATEGORY_PRODUCTS_LISTING, VTO_STATUS_UPDATE_SUB_CATEGORY } from "../../constants";

export const getSubCategoryListing = (id) => onResponse => {
    try {
        axiosInstance.get(SUB_CATEGORY_LISTING + `/${id}`)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getSubCategoryListingPaginate = (props) => onResponse => {
    const page = props?.page ? props?.page : ""
    const limit = props?.limit ? props?.limit : ""
    const id = props?.id ? props?.id : ""
    let BASE_URL = SUB_CATEGORY_LISTING + `/${id}?page=${page}&pageSize=${limit}`
    try {
        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const getSubCategoryProductsListing = (id) => onResponse => {
    try {
        axiosInstance.get(SUB_CATEGORY_PRODUCTS_LISTING + `/${id}`)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const createSubCategory = (props) => onResponse => {

    try {
        axiosInstance.post(CREATE_SUB_CATEGORY, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const editSubCategory = (props) => onResponse => {

    try {
        axiosInstance.post(EDIT_SUB_CATEGORY, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const statusSubCatUpdate = (id) => onResponse => {

    try {
        axiosInstance.delete(STATUS_UPDATE_SUB_CATEGORY + '/' + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const vtoStatusSubCatUpdate = (id) => onResponse => {

    try {
        axiosInstance.post(VTO_STATUS_UPDATE_SUB_CATEGORY + '/' + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const deleteSubCategory = (id) => onResponse => {

    try {
        axiosInstance.delete(DELETE_SUB_CATEGORY + '/' + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};